import { render, staticRenderFns } from "./MultiplyIcon.vue?vue&type=template&id=bd422554&scoped=true"
import script from "./MultiplyIcon.vue?vue&type=script&lang=js"
export * from "./MultiplyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd422554",
  null
  
)

export default component.exports